import React, { useEffect, useState } from 'react'
import { Panel } from 'primereact/panel'
import {
  PageHeader,
  CustomDataTableHeader,
  ImportExcelFile,
  TextBtn,
  CustomDropdown,
  Cnpj,
} from '../../../../components'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import {
  importarGradeContingencia,
  roteirizacaoGetEntregas,
} from '../../../../services/api/https/deliveries/roteirizacao-previa.http'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import AssociarPlacaPrevista from './AssociarPlacaPrevista'
import AssociarPlacaPrevistaManualmente from './AssociarPlacaPrevistaManualmente'

const RoteirizarEntregas = ({ history, dispatch }) => {
  // Constants
  const { roteirizacao } = history.location.state

  // Hooks
  const [acaoSelecionada, setAcaoSelecionado] = useState('')
  const [diaCrossSelecionado, setDiaCrossSelecionado] = useState('')
  const [entregasRoteirizadas, setEntregasRoteirizadas] = useState([])
  const [entregas, setEntregas] = useState([])

  useEffect(() => {
    async function fetchEntregas() {
      try {
        dispatch(showLoadingBox('Carregando as entregas ...', 'Aguarde'))
        const savedEntregas = await roteirizacaoGetEntregas(roteirizacao.id)
        setEntregas(savedEntregas.filter(e => e.selected))
      } catch (error) {
        dispatch(showMessageBox(null, errorHandler(error)))
      } finally {
        dispatch(hideLoadingBox())
      }
    }
    fetchEntregas()
  }, [])

  // Events
  const onFileImported = async content => {
    try {
      if (diaCrossSelecionado === '') throw new Error('Selecione o Dia do Cross')
      if (content && Array.isArray(content) && content.length === 0)
        throw new Error('O conteúdo do Arquivo está vazio')

      dispatch(showLoadingBox('Importando as informações ...', 'Aguarde'))
      const fetchedEntregasRoteirizadas = await importarGradeContingencia(
        roteirizacao.id,
        content,
        diaCrossSelecionado,
      )
      setEntregasRoteirizadas(fetchedEntregasRoteirizadas)
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }
  const onBtnVoltar = () => history.goBack()

  const onUpdateComplete = entregas => setEntregas(entregas.filter(e => e.selected))

  // Render
  return (
    <>
      <PageHeader>Roteirizar Entregas</PageHeader>
      <div style={{ marginTop: 16 }}>
        <Panel header={<TextBtn onClick={onBtnVoltar}>Voltar</TextBtn>}>
          <div className="p-grid">
            <div className="p-col-4">
              <CustomDropdown
                showLabel={true}
                label="Métodos de Roteirização"
                marginTop={0}
                optionLabel="label"
                options={[
                  { label: '001 - Rotas de Entrega', value: '001' },
                  { label: '002 - Arq. Excel : Grade Contingência', value: '002' },
                  { label: '003 - Associar Placa Prevista', value: '003' },
                  { label: '004 - Associar Placa Prevista - Manual', value: '004' },
                ]}
                value={acaoSelecionada}
                onChange={metodo => setAcaoSelecionado(metodo)}
              />
            </div>
            <AssociarPlacaPrevista
              entregas={entregas}
              acaoSelecionada={acaoSelecionada}
              roteirizacao={roteirizacao}
              onUpdateComplete={onUpdateComplete}
            />
            {acaoSelecionada !== '' && acaoSelecionada.value === '002' && (
              <div className="p-col-3">
                <CustomDropdown
                  showLabel={true}
                  label="Dia do Cross"
                  marginTop={0}
                  options={[
                    { label: 'Segunda-Feira', value: 'Segunda' },
                    { label: 'Terça-Feira', value: 'Terça' },
                    { label: 'Quarta-Feira', value: 'Quarta' },
                    { label: 'Quinta-Feira', value: 'Quinta' },
                    { label: 'Sexta-Feira', value: 'Sexta' },
                    { label: 'Sabado', value: 'Sabado' },
                    { label: 'Domingo', value: 'Domingo' },
                  ]}
                  value={diaCrossSelecionado}
                  onChange={dia => setDiaCrossSelecionado(dia)}
                />
              </div>
            )}
            {acaoSelecionada !== '' && acaoSelecionada.value === '002' && (
              <div className="p-col-2" style={{ paddingTop: 27 }}>
                <ImportExcelFile
                  label="Importar"
                  classes="btnImportar"
                  onFileImported={onFileImported}
                />
              </div>
            )}
            {entregasRoteirizadas.length > 0 ? (
              <div className="p-col-12">
                <ResultadoGradeContingencia entregasRoteirizadas={entregasRoteirizadas} />
              </div>
            ) : null}
            <AssociarPlacaPrevistaManualmente
              entregas={entregas}
              acaoSelecionada={acaoSelecionada}
              roteirizacao={roteirizacao}
              onUpdateComplete={onUpdateComplete}
            />
          </div>
        </Panel>
      </div>
    </>
  )
}

function ResultadoGradeContingencia({ entregasRoteirizadas }) {
  // Hooks
  const [globalFilter, setGlobalFilter] = useState('')

  // Render
  return (
    <DataTable
      value={entregasRoteirizadas}
      globalFilter={globalFilter}
      header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
      paginator={true}
      rows={20}
    >
      <Column field={'identifier'} header={'Identificador'} style={tableCellCentered(150)} />
      <Column field={'nomeFantasia'} header={'Cliente'} />
      <Column
        field={'cnpj'}
        header={'CNPJ'}
        style={tableCellCentered(150)}
        body={entrega => <Cnpj>{entrega.cnpj}</Cnpj>}
      />
      <Column field={'companyName'} header={'Empresa'} style={tableCellCentered(150)} />
      <Column field={'rotaName'} header={'Rota'} style={tableCellCentered(150)} />
      <Column field={'dia_carregamento'} header={'Dia Carreg.'} style={tableCellCentered(150)} />
      <Column
        field={'horario_carregamento'}
        header={'Horário Carreg.'}
        style={tableCellCentered(150)}
      />
    </DataTable>
  )
}
export default connect()(withRouter(RoteirizarEntregas))
